"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarLineOffCommand = void 0;
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
/**
 * Turns off the visual appearance of measure lines until the next #BARLINEON
 * command.
 */
class BarLineOffCommand extends Command_1.Command {
    constructor() {
        super(CommandType_1.CommandType.BarLineOff);
    }
    static parse(_args) {
        return new BarLineOffCommand();
    }
}
exports.BarLineOffCommand = BarLineOffCommand;
